import { TabsProps } from 'antd'
import { Tab } from 'rc-tabs/lib/interface'

import { AUCTION_TYPES } from '../../common/auctionScrapeTypes'
import { PROPERTY_TYPES } from '../../common/drmTypes'
import { TABLE_VIEW } from '../../common/foreclosureMonitoringTypes'
import { LABEL_TAB_KEY } from './labelsTypes'

export const tabsProps: TabsProps = {
  type: 'card',
  size: 'large',
  tabBarGutter: 6,
  tabBarStyle: { marginBottom: 0 },
}

export interface TabItem<T extends string> extends Omit<Tab, 'key'> {
  key: T
}

export enum COLLECTION_TAB_KEYS {
  TABLE = 'Tabulka',
  DOCUMENT = 'Listina',
  RESTRICTIONS = 'Cizi-pravni-vztahy',
}

export const COLLECTION_TABS = {
  [COLLECTION_TAB_KEYS.TABLE]: 'Tabulka',
  [COLLECTION_TAB_KEYS.DOCUMENT]: 'Listina',
  [COLLECTION_TAB_KEYS.RESTRICTIONS]: 'Cizí právní vztahy',
}

export enum SUBJECT_TAB_KEYS {
  OWNERSHIP = 'Vlastnicka-prava',
  SUMMARY = 'Sumace-pozemku',
}

export const SUBJECT_TABS = {
  [SUBJECT_TAB_KEYS.OWNERSHIP]: 'Vlastnická práva',
  [SUBJECT_TAB_KEYS.SUMMARY]: 'Sumace pozemků',
}

export enum STATISTIC_TAB_KEYS {
  CEE = 'CEE',
  PRICE_ESTIMATE = 'Cenove-odhady',
  CPOST = 'Hromadna-posta',
  MARKETPLACE = 'Marketplace',
}

export enum MONITORING_TAB_KEYS {
  AREA = 'Pozemky',
  BUILDING = 'Budovy',
  UNIT = 'Jednotky',
  OTHER = 'Ostatni',
}

export const MONITORING_TABS = {
  [MONITORING_TAB_KEYS.AREA]: 'Pozemky',
  [MONITORING_TAB_KEYS.BUILDING]: 'Budovy',
  [MONITORING_TAB_KEYS.UNIT]: 'Jednotky',
  [MONITORING_TAB_KEYS.OTHER]: 'Ostatní',
}

export const monitoringTabSlug: Record<PROPERTY_TYPES, MONITORING_TAB_KEYS> = {
  [PROPERTY_TYPES.AREA]: MONITORING_TAB_KEYS.AREA,
  [PROPERTY_TYPES.BUILDING]: MONITORING_TAB_KEYS.BUILDING,
  [PROPERTY_TYPES.UNIT]: MONITORING_TAB_KEYS.UNIT,
}

export const auctionTabSlug: Record<AUCTION_TYPES, MONITORING_TAB_KEYS> = {
  [AUCTION_TYPES.AREA]: MONITORING_TAB_KEYS.AREA,
  [AUCTION_TYPES.BUILDING]: MONITORING_TAB_KEYS.BUILDING,
  [AUCTION_TYPES.UNIT]: MONITORING_TAB_KEYS.UNIT,
  [AUCTION_TYPES.UNKNOWN]: MONITORING_TAB_KEYS.OTHER,
}

export const monitoringViewSlug: Record<TABLE_VIEW, string> = {
  [TABLE_VIEW.TABLE]: 'Tabulka',
  [TABLE_VIEW.TILES]: 'Náhledy',
  [TABLE_VIEW.COMPACT_TABLE]: 'Přehled',
}

export const labelTabSlug: Record<LABEL_TAB_KEY, string> = {
  propertyLabelId: 'Nemovitosti',
  monitoringCuzkRcId: 'CUZK-osoby',
  monitoringCeeId: 'CEE',
  monitId: 'Cenove-odhady',
  cuzkEpoId: 'Evidence-prav',
  cuzkLvId: 'Listy-vlastnictvi',
  cuzkDocumentCollectionId: 'CUZK-listiny',
  auctionListingId: 'Drazby',
  postserviceListId: 'Seznamy-adresatu-hromadna-posta',
  unassigned: 'Neprirazeno',
}

export const LABEL_TABS = {
  [labelTabSlug.propertyLabelId]: 'Nemovitosti',
  [labelTabSlug.monitoringCuzkRcId]: 'ČÚZK osoby',
  [labelTabSlug.monitoringCeeId]: 'CEE',
  [labelTabSlug.monitId]: 'Cenové odhady',
  [labelTabSlug.cuzkEpoId]: 'Evidence práv pro osobu',
  [labelTabSlug.cuzkLvId]: 'Listy vlastnictví',
  [labelTabSlug.cuzkDocumentCollectionId]: 'CUZK listiny',
  [labelTabSlug.auctionListingId]: 'Dražby',
  [labelTabSlug.postserviceListId]: 'Seznamy adresátů hromadná pošta',
  [labelTabSlug.unassigned]: 'Nepřiřazeno',
}
